import { List } from 'foundations-components/transitional/components/List';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { FeaturesDisplayLayoutUI } from '../../../../components/merch-card/feature-display/FeaturesDisplayLayoutUI';
import { CUSTOMER_PLATFORM_BUNDLE_SKU_CATEGORY_NAMES } from '../../../../utils/validTypeValues';
import { CustomerPlatformFeatureItem } from './CustomerPlatformFeatureItem';
import { getI18nTextForFeaturesHeader } from './customerPlatformFeatureDisplayI18nUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const CustomerPlatformFeaturesContainer = ({
  productLevel,
  productApiName
}) => {
  const isCollapsible = useIsMobile();
  const FeaturesListSection = /*#__PURE__*/_jsx(List, {
    children: CUSTOMER_PLATFORM_BUNDLE_SKU_CATEGORY_NAMES.map((skuCategoryName, index) => {
      return /*#__PURE__*/_jsx(CustomerPlatformFeatureItem, {
        skuCategoryName: skuCategoryName,
        productLevel: productLevel,
        index: index,
        productApiName: productApiName
      }, skuCategoryName);
    })
  });
  return /*#__PURE__*/_jsx(FeaturesDisplayLayoutUI, {
    HeaderSection: getI18nTextForFeaturesHeader({
      productLevel
    }),
    FeaturesListSection: FeaturesListSection,
    isCollapsible: isCollapsible
  });
};